import React, { useState, useEffect } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Box,
} from "@mui/material";
import { generateClient } from "aws-amplify/api";
import {
  listAlbums,
  listSeries,
  seasonsBySeriesID,
} from "../../graphql/queries";
import { useDispatch, useSelector } from "react-redux";
import {
  setAlbumId,
  setSeries,
  setSeriesID,
} from "../../redux/slices/contentSlice/contentForm/contentForm";
import CreateSeries from "./CreateSeries";
import CreateAlbum from "./CreateAlbum";

const SelectAlbum = ({ formik }) => {
  const client = generateClient();
  const [albumList, setAlbumList] = useState([]);
  const [selectedAlbum, setSelectedAlbum] = useState("");
  const [loading, setLoading] = useState(false);
  const albumCreated = useSelector((state) => state.contentForm.albumCreated);
  const dispatch = useDispatch();

  const fetchAlbums = async () => {
    try {
      setLoading(true);
      const albumResponse = await client.graphql({
        query: listAlbums,
      });
      const albums = albumResponse.data.listAlbums.items;
      setAlbumList(albums);
    } catch (error) {
      console.error("Error fetching albums", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlbums();
  }, [albumCreated]);

  const handleChange = (event) => {
    setSelectedAlbum(event.target.value);
    dispatch(setAlbumId(event.target.value));
    formik.setFieldValue("albumId", event.target.value);
  };

  return (
    <Box display={"flex"} gap={1} alignItems={"flex-end"}>
      <FormControl fullWidth variant="outlined">
        <label
          style={{ margin: "10px 0", textWrap: "nowrap" }}
          htmlFor={"select-album"}
        >
          Select Album
          <span style={{ color: "red", marginLeft: "5px" }}>*</span>
        </label>
        {loading ? (
          <CircularProgress />
        ) : (
          <Select
            labelId="select-album"
            value={selectedAlbum}
            onChange={handleChange}
          >
            {albumList.map((album) => (
              <MenuItem key={album.id} value={album.id}>
                {album.title}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
      <CreateAlbum />
    </Box>
  );
};

export default SelectAlbum;